<template>
  <ProgramCardModal
    :programArticle="selectedProgramArticle"
    @close="clearSelectedArticle"
  />

  <div class="md:hidden">
    <div>
      <p class="lg:text-[64px] text-[32px] font-semibold mb-4">Program</p>
    </div>
<!--    <article class="relative">-->
<!--      <div-->
<!--        class="-->
<!--          bg-brand-green-->
<!--          absolute-->
<!--          px-2-->
<!--          flex-->
<!--          items-center-->
<!--          h-8-->
<!--          -top-8-->
<!--          rounded-t-md-->
<!--          left-4-->
<!--          w-[288px]-->
<!--        "-->
<!--      >-->
<!--        <p class="text-body text-white font-semibold">9:30—9:45</p>-->
<!--      </div>-->

<!--      <div-->
<!--        class="-->
<!--          bg-white-->
<!--          rounded-md-->
<!--          h-[80px]-->
<!--          flex-->
<!--          justify-between-->
<!--          items-center-->
<!--          relative-->
<!--          shadow-md-->
<!--          max-w-[340px]-->
<!--          px-4-->
<!--          mb-2-->
<!--        "-->
<!--      >-->
<!--        <p class="text-big-body text-brand-gray-900 font-semibold">-->
<!--          Zahájení konference-->
<!--        </p>-->

<!--        <svg-->
<!--          width="48"-->
<!--          height="48"-->
<!--          viewBox="0 0 48 48"-->
<!--          fill="none"-->
<!--          xmlns="http://www.w3.org/2000/svg"-->
<!--        >-->
<!--          <path-->
<!--            d="M23.5469 1.98048C23.2995 1.9715 23.0538 2.02385 22.8317 2.13286C22.6095 2.24188 22.4177 2.40416 22.2735 2.60526C22.1292 2.80636 22.037 3.04002 22.0049 3.28542C21.9729 3.53082 22.0021 3.78034 22.0898 4.01173C23.0275 6.59023 23.2056 8.47473 22.7383 10.2402C22.3426 11.735 21.3948 13.2555 19.8203 14.9883L18.8574 14.0254C17.9717 13.1397 16.741 12.8724 15.6269 13.1211C14.5129 13.3698 13.5153 14.1362 13.0898 15.3145L3.08983 42.9902C2.99329 43.2581 2.97498 43.548 3.03705 43.8259C3.09912 44.1038 3.23901 44.3583 3.44036 44.5596C3.64171 44.761 3.89622 44.9009 4.17412 44.963C4.45203 45.025 4.74187 45.0067 5.00976 44.9102L32.6875 34.9102V34.9121C35.0448 34.0625 35.7451 30.9167 33.9746 29.1445C33.9746 29.1439 33.9746 29.1432 33.9746 29.1426L33.0019 28.1699C34.7385 26.5903 36.2624 25.6405 37.7598 25.2442C39.5253 24.7768 41.4098 24.955 43.9883 25.8926C44.1737 25.9609 44.3708 25.9919 44.5683 25.9838C44.7657 25.9757 44.9596 25.9287 45.1389 25.8455C45.3181 25.7622 45.4791 25.6444 45.6126 25.4987C45.7462 25.353 45.8496 25.1824 45.9171 24.9967C45.9845 24.8109 46.0145 24.6136 46.0055 24.4162C45.9964 24.2188 45.9484 24.0251 45.8643 23.8463C45.7802 23.6675 45.6616 23.5071 45.5152 23.3742C45.3689 23.2414 45.1978 23.1388 45.0117 23.0723C43.551 22.5411 42.1675 22.1939 40.8379 22.0625C39.5083 21.9311 38.2325 22.0149 36.9902 22.3438C34.8345 22.9144 32.8789 24.176 30.8652 26.0332L26.582 21.75C27.0203 21.5797 27.4685 21.5494 28.1211 21.4961C29.276 21.4017 31.0694 21.1721 32.6191 19.6231C34.1695 18.0727 34.3974 16.2804 34.4922 15.125C34.5869 13.9696 34.5476 13.4521 35.498 12.502C36.4486 11.5518 36.9675 11.591 38.123 11.4961C39.2785 11.4012 41.0713 11.1716 42.6211 9.6211C42.8376 9.41024 42.9854 9.13888 43.0451 8.84258C43.1048 8.54628 43.0736 8.23886 42.9556 7.96061C42.8375 7.68235 42.6382 7.44623 42.3837 7.28319C42.1292 7.12014 41.8314 7.03778 41.5293 7.04689C41.1404 7.05874 40.7714 7.22121 40.5 7.50001C39.5498 8.45056 39.0322 8.41101 37.8769 8.50587C36.7217 8.60074 34.9274 8.83104 33.3769 10.3809C31.8264 11.9308 31.5986 13.7235 31.5039 14.8789C31.4091 16.0343 31.4486 16.5514 30.498 17.502C29.5487 18.4509 29.0321 18.4115 27.8769 18.5059C26.9687 18.5801 25.6652 18.7472 24.3965 19.5645L21.957 17.125C23.8091 15.1147 25.067 13.1622 25.6367 11.0098C26.2944 8.52529 25.9725 5.90979 24.9101 2.98829C24.811 2.70242 24.6278 2.4532 24.3845 2.27334C24.1412 2.09348 23.8492 1.99139 23.5469 1.98048ZM31 4.00001C30.6772 4.00001 30.3539 4.12265 30.1074 4.36915L29.3691 5.10743C28.8761 5.60043 28.8761 6.39959 29.3691 6.89259L30.1074 7.63087C30.6004 8.12287 31.3996 8.12287 31.8926 7.63087L32.6308 6.89259C33.1238 6.39959 33.1238 5.60043 32.6308 5.10743L31.8926 4.36915C31.6461 4.12265 31.3227 4.00001 31 4.00001ZM15 7.00001C14.6772 7.00001 14.3539 7.12265 14.1074 7.36915L13.3691 8.10743C12.8761 8.60043 12.8761 9.39959 13.3691 9.89259L14.1074 10.6309C14.6004 11.1229 15.3996 11.1229 15.8926 10.6309L16.6308 9.89259C17.1238 9.39959 17.1238 8.60043 16.6308 8.10743L15.8926 7.36915C15.6461 7.12265 15.3227 7.00001 15 7.00001ZM8.99999 11.5C8.67724 11.5 8.35391 11.6227 8.10741 11.8692L7.36913 12.6074C6.87613 13.1004 6.87613 13.8996 7.36913 14.3926L8.10741 15.1309C8.60041 15.6229 9.39957 15.6229 9.89257 15.1309L10.6309 14.3926C11.1238 13.8996 11.1238 13.1004 10.6309 12.6074L9.89257 11.8692C9.64607 11.6227 9.32274 11.5 8.99999 11.5ZM16.2656 15.9766C16.416 15.943 16.5841 15.9982 16.7344 16.1484C16.735 16.1484 16.7357 16.1484 16.7363 16.1484L31.8535 31.2656C32.1531 31.5672 32.0698 31.9438 31.6699 32.0879C31.6693 32.0886 31.6686 32.0892 31.668 32.0899L6.99608 41.0039L15.9101 16.332C15.9826 16.1313 16.1152 16.0102 16.2656 15.9766ZM40 16C39.6772 16 39.3539 16.1227 39.1074 16.3692L38.3691 17.1074C37.8761 17.6004 37.8761 18.3996 38.3691 18.8926L39.1074 19.6309C39.6004 20.1229 40.3996 20.1229 40.8926 19.6309L41.6309 18.8926C42.1239 18.3996 42.1239 17.6004 41.6309 17.1074L40.8926 16.3692C40.6461 16.1227 40.3227 16 40 16ZM40 29C39.6772 29 39.3539 29.1227 39.1074 29.3692L38.3691 30.1074C37.8761 30.6004 37.8761 31.3996 38.3691 31.8926L39.1074 32.6309C39.6004 33.1229 40.3996 33.1229 40.8926 32.6309L41.6309 31.8926C42.1239 31.3996 42.1239 30.6004 41.6309 30.1074L40.8926 29.3692C40.6461 29.1227 40.3227 29 40 29ZM37 36C36.6772 36 36.3539 36.1227 36.1074 36.3692L35.3691 37.1074C34.8761 37.6004 34.8761 38.3996 35.3691 38.8926L36.1074 39.6309C36.6004 40.1229 37.3996 40.1229 37.8926 39.6309L38.6309 38.8926C39.1239 38.3996 39.1239 37.6004 38.6309 37.1074L37.8926 36.3692C37.6461 36.1227 37.3227 36 37 36Z"-->
<!--            fill="#A6C71F"-->
<!--          />-->
<!--        </svg>-->
<!--      </div>-->
<!--    </article>-->

    <div
      class=""
    >

      <!-- REMOVED FOR 2023 to be returned -->

      <!-- <article class="relative mt-16" v-if="index === 3">
      <div
        class="
          bg-brand-green
          absolute
          px-2
          flex
          items-center
          h-8
          -top-8
          rounded-t-md
          left-4
          w-[288px]
        "
      >
        <p class="text-body text-white font-semibold">12:30—14:00</p>
      </div>

      <div
        class="
          bg-white
          rounded-md
          h-[80px]
          flex
          justify-between
          items-center
          relative
          shadow-md
          max-w-[340px]
          px-4
          mb-2
        "
      >
        <p class="text-big-body text-brand-gray-900 font-semibold">
          Oběd
        </p>

        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.4766 5.97845C29.0791 5.98466 28.7003 6.14839 28.4235 6.43367C28.1466 6.71895 27.9943 7.10245 28 7.49994V17.4999C28 21.0933 30.6126 23.9758 34 24.6953V41.4999C33.9972 41.6987 34.0339 41.8961 34.108 42.0805C34.1822 42.265 34.2922 42.4328 34.4318 42.5744C34.5713 42.7159 34.7376 42.8284 34.921 42.9051C35.1044 42.9818 35.3012 43.0213 35.5 43.0213C35.6988 43.0213 35.8956 42.9818 36.079 42.9051C36.2624 42.8284 36.4287 42.7159 36.5682 42.5744C36.7078 42.4328 36.8178 42.265 36.892 42.0805C36.9661 41.8961 37.0028 41.6987 37 41.4999V24.6953C40.3874 23.9758 43 21.0933 43 17.4999V7.49994C43.0028 7.30117 42.9661 7.10383 42.892 6.91937C42.8178 6.73492 42.7078 6.56704 42.5682 6.42549C42.4287 6.28393 42.2624 6.17153 42.079 6.09481C41.8956 6.01808 41.6988 5.97858 41.5 5.97858C41.3012 5.97858 41.1044 6.01808 40.921 6.09481C40.7376 6.17153 40.5713 6.28393 40.4318 6.42549C40.2922 6.56704 40.1822 6.73492 40.108 6.91937C40.0339 7.10383 39.9972 7.30117 40 7.49994V17.4999C40 19.47 38.7468 21.0848 37 21.7011V7.49994C37.0028 7.30117 36.9661 7.10383 36.892 6.91937C36.8178 6.73492 36.7078 6.56704 36.5682 6.42549C36.4287 6.28393 36.2624 6.17153 36.079 6.09481C35.8956 6.01808 35.6988 5.97858 35.5 5.97858C35.3012 5.97858 35.1044 6.01808 34.921 6.09481C34.7376 6.17153 34.5713 6.28393 34.4318 6.42549C34.2922 6.56704 34.1822 6.73492 34.108 6.91937C34.0339 7.10383 33.9972 7.30117 34 7.49994V21.7011C32.2532 21.0848 31 19.47 31 17.4999V7.49994C31.0029 7.29917 30.9654 7.09987 30.8899 6.91385C30.8143 6.72782 30.7022 6.55886 30.5601 6.41698C30.418 6.27509 30.2489 6.16317 30.0628 6.08784C29.8767 6.01251 29.6773 5.97532 29.4766 5.97845ZM6.5 5.99994C6.10219 5.99998 5.72068 6.15803 5.43938 6.43932C5.15809 6.72062 5.00004 7.10213 5 7.49994V20.4999C5 25.1973 8.50828 28.946 13 29.6953V39.9999H9.5C9.30123 39.9971 9.10389 40.0339 8.91944 40.108C8.73498 40.1821 8.5671 40.2921 8.42555 40.4317C8.28399 40.5713 8.17159 40.7376 8.09487 40.921C8.01815 41.1043 7.97864 41.3012 7.97864 41.4999C7.97864 41.6987 8.01815 41.8955 8.09487 42.0789C8.17159 42.2623 8.28399 42.4286 8.42555 42.5682C8.5671 42.7077 8.73498 42.8178 8.91944 42.8919C9.10389 42.966 9.30123 43.0028 9.5 42.9999H14.2539C14.4149 43.0264 14.5792 43.0264 14.7402 42.9999H19.5C19.6988 43.0028 19.8961 42.966 20.0806 42.8919C20.265 42.8178 20.4329 42.7077 20.5745 42.5682C20.716 42.4286 20.8284 42.2623 20.9051 42.0789C20.9819 41.8955 21.0214 41.6987 21.0214 41.4999C21.0214 41.3012 20.9819 41.1043 20.9051 40.921C20.8284 40.7376 20.716 40.5713 20.5745 40.4317C20.4329 40.2921 20.265 40.1821 20.0806 40.108C19.8961 40.0339 19.6988 39.9971 19.5 39.9999H16V29.6953C20.4917 28.946 24 25.1973 24 20.4999V7.49994C24 7.10213 23.8419 6.72062 23.5606 6.43932C23.2793 6.15803 22.8978 5.99998 22.5 5.99994H6.5ZM8 8.99994H21V20.4999C21 24.0766 18.1504 26.9339 14.5859 26.9824C14.5287 26.9791 14.4713 26.9791 14.4141 26.9824C10.8496 26.9339 8 24.0766 8 20.4999V8.99994Z"
            fill="#A6C71F"
          />
        </svg>
      </div>
    </article> -->
      <div v-for="(happening, i) in programFiltered" :key="i">
        <div
          v-if="i === 0"
          class="
            max-w-[390px]
            md:max-w-none
            p-7
            bg-[#00120C]
            relative
            border
            border-[#19291E]
            m-auto
            "
        >
          <div class="flex items-center">
            <div class="mr-3 font-semibold text-brand-green text-[16px] font-mono">14:30</div>
            <div class="uppercase font-semibold text-brand-gray-500 text-[16px] font-mono">Notino pre-event</div>
          </div>
        </div>
        <ProgramCard
          :key="i"
          class="m-auto !max-w-[390px]"
          :programArticle="happening"
          @clicked="selectProgramArticle"
          :timeslotSelections="timeslotSelectionsMutable"
          :userLoggedIn="userLoggedIn"
          :program-voting-opened="votingOpened"
          @update:timeslotSelections="updateTimeSlot"
          :hasHappeningSiblingDown="hasHappeningSiblingDown(happening)"
          :hasHappeningSiblingUp="hasHappeningSiblingUp(happening)"
        />
        <div
          v-if="i === 0"
          class="
            max-w-[390px]
            md:max-w-none
            p-7
            bg-[#00120C]
            relative
            border
            border-[#19291E]
            m-auto
            "
        >
          <div class="flex items-center">
            <div class="mr-3 font-semibold text-brand-green text-[16px] font-mono">16:00</div>
            <div class="uppercase font-semibold text-brand-gray-500 text-[16px] font-mono">Slavnostní zahájení</div>
          </div>
        </div>
        <div
          v-if="i < programFiltered.length-1 && programFiltered[i+1].start !== happening.end && i !== 6 && i !== 0"
          class="
            max-w-[390px]
            md:max-w-none
            p-7
            bg-[#00120C]
            relative
            border
            border-[#19291E]
            m-auto
            "
        >
          <div class="flex items-center">
            <div class="uppercase font-semibold text-brand-gray-500 text-[16px] font-mono">Pauza</div>
          </div>
        </div>
        <div
          v-if="i === 6"
          class="
            max-w-[390px]
            md:max-w-none
            p-7
            bg-[#00120C]
            relative
            border
            border-[#19291E]
            m-auto
            "
        >
          <div class="flex items-center">
            <div class="uppercase font-semibold text-brand-gray-500 text-[16px] font-mono">Večeře</div>
          </div>
        </div>
      </div>
      <div
        class="
            md:min-h-[250px]
            max-w-[390px]
            md:max-w-none
            p-6
            bg-brand-gray-900
            relative
            border
            border-brand-green
            m-auto
          "
      >
        <div class="flex justify-between">
          <div class="flex">
            <svg class="w-[85px] h-[85px] mr-4 object-cover rounded-md" xmlns="http://www.w3.org/2000/svg" width="85" height="85" viewBox="0 0 50 43" fill="none">
              <circle cx="24.7368" cy="13.2232" r="5.71924" stroke="white" stroke-width="2.34378"/>
              <circle cx="37.9024" cy="18.879" r="4.12898" stroke="white" stroke-width="2.34378"/>
              <circle cx="11.5743" cy="18.879" r="4.12898" stroke="white" stroke-width="2.34378"/>
              <path d="M36.2235 35.3996C36.2235 28.8125 31.2792 23.4727 25.18 23.4727C19.0809 23.4727 14.1366 28.8125 14.1366 35.3996M19.6141 36.1947C19.6141 31.413 16.1135 27.5367 11.7953 27.5367C7.47715 27.5367 3.97656 31.413 3.97656 36.1947M45.7651 36.1947C45.7651 31.413 42.2645 27.5367 37.9463 27.5367C33.6281 27.5367 30.1275 31.413 30.1275 36.1947" stroke="white" stroke-width="2.34378" stroke-linecap="round"/>
            </svg>

            <div>
              <p class="font-semibold text-brand-green text-[14px] font-mono mb-3">
                21:00-22:00
              </p>
              <p
                class="
                    font-semibold
                    text-[24px]
                    leading-7
                  "
              >
                Mastermind skupiny a řízený networking
              </p>
            </div>
          </div>
        </div>
        <div class="mt-4 font-medium text-body  text-brand-gray-500">
          Zúčastněte se malých uzavřených skupin vedených zkušenými mentory a diskutujte s ostatními na konkrétní téma.
        </div>
        <div
          class="mt-6 mb-5"
        >
          <a
            :href="userLoggedIn ? '/#workshopy' : '/prihlaseni'"
            class="uppercase px-6 py-3 text-[16px] hover:opacity-80 text-black bg-brand-green border border-brand-green hover:border-brand-green hover:text-brand-green hover:bg-brand-gray-700 hover:cursor-pointer font-mono"
          >
            Přihlásit se
          </a>
        </div>
      </div>
      <div
        class="
            max-w-[390px]
            md:max-w-none
            p-2
            pl-2
            bg-[#00120C]
            relative
            border
            border-[#19291E]
            m-auto
            "
      >
        <div class="flex items-center">
          <div class="mr-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="113" height="113" viewBox="0 0 113 113" fill="none">
              <path d="M55.5459 35.001C55.2986 34.992 55.0529 35.0444 54.8307 35.1534C54.6085 35.2624 54.4167 35.4247 54.2725 35.6258C54.1282 35.8269 54.036 36.0605 54.004 36.3059C53.9719 36.5513 54.0011 36.8008 54.0889 37.0322C55.0265 39.6107 55.2046 41.4952 54.7373 43.2608C54.3416 44.7555 53.3938 46.276 51.8193 48.0088L50.8564 47.0459C49.9707 46.1602 48.74 45.893 47.626 46.1416C46.5119 46.3903 45.5144 47.1567 45.0889 48.335L35.0889 76.0108C34.9923 76.2786 34.974 76.5685 35.0361 76.8464C35.0981 77.1243 35.238 77.3788 35.4394 77.5802C35.6407 77.7815 35.8952 77.9214 36.1731 77.9835C36.4511 78.0455 36.7409 78.0272 37.0088 77.9307L64.6865 67.9307V67.9326C67.0439 67.083 67.7441 63.9373 65.9736 62.1651C65.9736 62.1644 65.9736 62.1637 65.9736 62.1631L65.001 61.1904C66.7375 59.6109 68.2614 58.661 69.7588 58.2647C71.5243 57.7973 73.4088 57.9755 75.9873 58.9131C76.1727 58.9814 76.3698 59.0124 76.5673 59.0043C76.7647 58.9962 76.9587 58.9492 77.1379 58.866C77.3171 58.7827 77.4781 58.6649 77.6117 58.5192C77.7452 58.3736 77.8487 58.2029 77.9161 58.0172C77.9835 57.8314 78.0135 57.6341 78.0045 57.4367C77.9954 57.2393 77.9475 57.0456 77.8633 56.8668C77.7792 56.688 77.6606 56.5276 77.5143 56.3947C77.368 56.2619 77.1968 56.1593 77.0107 56.0928C75.55 55.5616 74.1665 55.2144 72.8369 55.083C71.5073 54.9516 70.2315 55.0354 68.9893 55.3643C66.8335 55.9349 64.8779 57.1965 62.8642 59.0537L58.581 54.7705C59.0193 54.6002 59.4676 54.5699 60.1201 54.5166C61.275 54.4222 63.0685 54.1926 64.6182 52.6436C66.1686 51.0932 66.3965 49.3009 66.4912 48.1455C66.586 46.9902 66.5466 46.4726 67.4971 45.5225C68.4476 44.5723 68.9666 44.6115 70.1221 44.5166C71.2776 44.4217 73.0703 44.1921 74.6201 42.6416C74.8367 42.4307 74.9844 42.1594 75.0441 41.8631C75.1038 41.5668 75.0726 41.2594 74.9546 40.9811C74.8366 40.7029 74.6372 40.4667 74.3827 40.3037C74.1282 40.1407 73.8304 40.0583 73.5283 40.0674C73.1394 40.0792 72.7704 40.2417 72.499 40.5205C71.5489 41.4711 71.0312 41.4315 69.876 41.5264C68.7207 41.6212 66.9264 41.8515 65.376 43.4014C63.8254 44.9513 63.5977 46.744 63.5029 47.8994C63.4082 49.0548 63.4476 49.5719 62.4971 50.5225C61.5478 51.4714 61.0311 51.432 59.876 51.5264C58.9677 51.6006 57.6642 51.7677 56.3955 52.585L53.956 50.1455C55.8082 48.1352 57.066 46.1827 57.6357 44.0303C58.2934 41.5458 57.9715 38.9303 56.9092 36.0088C56.8101 35.7229 56.6268 35.4737 56.3835 35.2938C56.1402 35.114 55.8483 35.0119 55.5459 35.001ZM62.999 37.0205C62.6763 37.0205 62.3529 37.1432 62.1064 37.3897L61.3682 38.1279C60.8752 38.6209 60.8752 39.4201 61.3682 39.9131L62.1064 40.6514C62.5994 41.1434 63.3986 41.1434 63.8916 40.6514L64.6299 39.9131C65.1229 39.4201 65.1229 38.6209 64.6299 38.1279L63.8916 37.3897C63.6451 37.1432 63.3218 37.0205 62.999 37.0205ZM46.999 40.0205C46.6763 40.0205 46.3529 40.1432 46.1064 40.3897L45.3682 41.1279C44.8752 41.6209 44.8752 42.4201 45.3682 42.9131L46.1064 43.6514C46.5994 44.1434 47.3986 44.1434 47.8916 43.6514L48.6299 42.9131C49.1229 42.4201 49.1229 41.6209 48.6299 41.1279L47.8916 40.3897C47.6451 40.1432 47.3218 40.0205 46.999 40.0205ZM40.999 44.5205C40.6763 44.5205 40.3529 44.6432 40.1064 44.8897L39.3682 45.6279C38.8752 46.1209 38.8752 46.9201 39.3682 47.4131L40.1064 48.1514C40.5994 48.6434 41.3986 48.6434 41.8916 48.1514L42.6299 47.4131C43.1229 46.9201 43.1229 46.1209 42.6299 45.6279L41.8916 44.8897C41.6451 44.6432 41.3218 44.5205 40.999 44.5205ZM48.2646 48.9971C48.4151 48.9635 48.5831 49.0187 48.7334 49.169C48.734 49.169 48.7347 49.169 48.7353 49.169L63.8525 64.2861C64.1521 64.5877 64.0689 64.9643 63.6689 65.1084C63.6683 65.1091 63.6676 65.1097 63.667 65.1104L38.9951 74.0244L47.9092 49.3525C47.9817 49.1518 48.1142 49.0307 48.2646 48.9971ZM71.999 49.0205C71.6763 49.0205 71.3529 49.1432 71.1064 49.3897L70.3682 50.1279C69.8752 50.6209 69.8752 51.4201 70.3682 51.9131L71.1064 52.6514C71.5994 53.1434 72.3986 53.1434 72.8916 52.6514L73.6299 51.9131C74.1229 51.4201 74.1229 50.6209 73.6299 50.1279L72.8916 49.3897C72.6451 49.1432 72.3218 49.0205 71.999 49.0205ZM71.999 62.0205C71.6763 62.0205 71.3529 62.1432 71.1064 62.3897L70.3682 63.1279C69.8752 63.6209 69.8752 64.4201 70.3682 64.9131L71.1064 65.6514C71.5994 66.1434 72.3986 66.1434 72.8916 65.6514L73.6299 64.9131C74.1229 64.4201 74.1229 63.6209 73.6299 63.1279L72.8916 62.3897C72.6451 62.1432 72.3218 62.0205 71.999 62.0205ZM68.999 69.0205C68.6763 69.0205 68.3529 69.1432 68.1064 69.3897L67.3682 70.1279C66.8752 70.6209 66.8752 71.4201 67.3682 71.9131L68.1064 72.6514C68.5994 73.1434 69.3986 73.1434 69.8916 72.6514L70.6299 71.9131C71.1229 71.4201 71.1229 70.6209 70.6299 70.1279L69.8916 69.3897C69.6451 69.1432 69.3218 69.0205 68.999 69.0205Z" fill="white"/>
              <g filter="url(#filter0_f_4256_4888)">
                <path d="M55.5459 35.001C55.2986 34.992 55.0529 35.0444 54.8307 35.1534C54.6085 35.2624 54.4167 35.4247 54.2725 35.6258C54.1282 35.8269 54.036 36.0605 54.004 36.3059C53.9719 36.5513 54.0011 36.8008 54.0889 37.0322C55.0265 39.6107 55.2046 41.4952 54.7373 43.2608C54.3416 44.7555 53.3938 46.276 51.8193 48.0088L50.8564 47.0459C49.9707 46.1602 48.74 45.893 47.626 46.1416C46.5119 46.3903 45.5144 47.1567 45.0889 48.335L35.0889 76.0108C34.9923 76.2786 34.974 76.5685 35.0361 76.8464C35.0981 77.1243 35.238 77.3788 35.4394 77.5802C35.6407 77.7815 35.8952 77.9214 36.1731 77.9835C36.4511 78.0455 36.7409 78.0272 37.0088 77.9307L64.6865 67.9307V67.9326C67.0439 67.083 67.7441 63.9373 65.9736 62.1651C65.9736 62.1644 65.9736 62.1637 65.9736 62.1631L65.001 61.1904C66.7375 59.6109 68.2614 58.661 69.7588 58.2647C71.5243 57.7973 73.4088 57.9755 75.9873 58.9131C76.1727 58.9814 76.3698 59.0124 76.5673 59.0043C76.7647 58.9962 76.9587 58.9492 77.1379 58.866C77.3171 58.7827 77.4781 58.6649 77.6117 58.5192C77.7452 58.3736 77.8487 58.2029 77.9161 58.0172C77.9835 57.8314 78.0135 57.6341 78.0045 57.4367C77.9954 57.2393 77.9475 57.0456 77.8633 56.8668C77.7792 56.688 77.6606 56.5276 77.5143 56.3947C77.368 56.2619 77.1968 56.1593 77.0107 56.0928C75.55 55.5616 74.1665 55.2144 72.8369 55.083C71.5073 54.9516 70.2315 55.0354 68.9893 55.3643C66.8335 55.9349 64.8779 57.1965 62.8642 59.0537L58.581 54.7705C59.0193 54.6002 59.4676 54.5699 60.1201 54.5166C61.275 54.4222 63.0685 54.1926 64.6182 52.6436C66.1686 51.0932 66.3965 49.3009 66.4912 48.1455C66.586 46.9902 66.5466 46.4726 67.4971 45.5225C68.4476 44.5723 68.9666 44.6115 70.1221 44.5166C71.2776 44.4217 73.0703 44.1921 74.6201 42.6416C74.8367 42.4307 74.9844 42.1594 75.0441 41.8631C75.1038 41.5668 75.0726 41.2594 74.9546 40.9811C74.8366 40.7029 74.6372 40.4667 74.3827 40.3037C74.1282 40.1407 73.8304 40.0583 73.5283 40.0674C73.1394 40.0792 72.7704 40.2417 72.499 40.5205C71.5489 41.4711 71.0312 41.4315 69.876 41.5264C68.7207 41.6212 66.9264 41.8515 65.376 43.4014C63.8254 44.9513 63.5977 46.744 63.5029 47.8994C63.4082 49.0548 63.4476 49.5719 62.4971 50.5225C61.5478 51.4714 61.0311 51.432 59.876 51.5264C58.9677 51.6006 57.6642 51.7677 56.3955 52.585L53.956 50.1455C55.8082 48.1352 57.066 46.1827 57.6357 44.0303C58.2934 41.5458 57.9715 38.9303 56.9092 36.0088C56.8101 35.7229 56.6268 35.4737 56.3835 35.2938C56.1402 35.114 55.8483 35.0119 55.5459 35.001ZM62.999 37.0205C62.6763 37.0205 62.3529 37.1432 62.1064 37.3897L61.3682 38.1279C60.8752 38.6209 60.8752 39.4201 61.3682 39.9131L62.1064 40.6514C62.5994 41.1434 63.3986 41.1434 63.8916 40.6514L64.6299 39.9131C65.1229 39.4201 65.1229 38.6209 64.6299 38.1279L63.8916 37.3897C63.6451 37.1432 63.3218 37.0205 62.999 37.0205ZM46.999 40.0205C46.6763 40.0205 46.3529 40.1432 46.1064 40.3897L45.3682 41.1279C44.8752 41.6209 44.8752 42.4201 45.3682 42.9131L46.1064 43.6514C46.5994 44.1434 47.3986 44.1434 47.8916 43.6514L48.6299 42.9131C49.1229 42.4201 49.1229 41.6209 48.6299 41.1279L47.8916 40.3897C47.6451 40.1432 47.3218 40.0205 46.999 40.0205ZM40.999 44.5205C40.6763 44.5205 40.3529 44.6432 40.1064 44.8897L39.3682 45.6279C38.8752 46.1209 38.8752 46.9201 39.3682 47.4131L40.1064 48.1514C40.5994 48.6434 41.3986 48.6434 41.8916 48.1514L42.6299 47.4131C43.1229 46.9201 43.1229 46.1209 42.6299 45.6279L41.8916 44.8897C41.6451 44.6432 41.3218 44.5205 40.999 44.5205ZM48.2646 48.9971C48.4151 48.9635 48.5831 49.0187 48.7334 49.169C48.734 49.169 48.7347 49.169 48.7353 49.169L63.8525 64.2861C64.1521 64.5877 64.0689 64.9643 63.6689 65.1084C63.6683 65.1091 63.6676 65.1097 63.667 65.1104L38.9951 74.0244L47.9092 49.3525C47.9817 49.1518 48.1142 49.0307 48.2646 48.9971ZM71.999 49.0205C71.6763 49.0205 71.3529 49.1432 71.1064 49.3897L70.3682 50.1279C69.8752 50.6209 69.8752 51.4201 70.3682 51.9131L71.1064 52.6514C71.5994 53.1434 72.3986 53.1434 72.8916 52.6514L73.6299 51.9131C74.1229 51.4201 74.1229 50.6209 73.6299 50.1279L72.8916 49.3897C72.6451 49.1432 72.3218 49.0205 71.999 49.0205ZM71.999 62.0205C71.6763 62.0205 71.3529 62.1432 71.1064 62.3897L70.3682 63.1279C69.8752 63.6209 69.8752 64.4201 70.3682 64.9131L71.1064 65.6514C71.5994 66.1434 72.3986 66.1434 72.8916 65.6514L73.6299 64.9131C74.1229 64.4201 74.1229 63.6209 73.6299 63.1279L72.8916 62.3897C72.6451 62.1432 72.3218 62.0205 71.999 62.0205ZM68.999 69.0205C68.6763 69.0205 68.3529 69.1432 68.1064 69.3897L67.3682 70.1279C66.8752 70.6209 66.8752 71.4201 67.3682 71.9131L68.1064 72.6514C68.5994 73.1434 69.3986 73.1434 69.8916 72.6514L70.6299 71.9131C71.1229 71.4201 71.1229 70.6209 70.6299 70.1279L69.8916 69.3897C69.6451 69.1432 69.3218 69.0205 68.999 69.0205Z" fill="white"/>
              </g>
              <defs>
                <filter id="filter0_f_4256_4888" x="0.624489" y="0.624489" width="111.757" height="111.771" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                  <feGaussianBlur stdDeviation="17.1878" result="effect1_foregroundBlur_4256_4888"/>
                </filter>
              </defs>
            </svg>
          </div>
          <div>
            <div class="mr-3 font-semibold text-brand-green text-[16px] font-mono">21:00-24:00</div>
            <div class="font-semibold text-[20px]">Notino Afterparty</div>
          </div>
        </div>
      </div>
  </div>

<!--     <article class="relative mt-16">-->
<!--      <div-->
<!--        class="-->
<!--          bg-brand-green-->
<!--          absolute-->
<!--          px-2-->
<!--          flex-->
<!--          items-center-->
<!--          h-8-->
<!--          -top-8-->
<!--          rounded-t-md-->
<!--          left-4-->
<!--          w-[288px]-->
<!--        "-->
<!--      >-->
<!--        <p class="text-body text-white font-semibold">18:00-22:00</p>-->
<!--      </div>-->

<!--      <div-->
<!--        class="-->
<!--          bg-white-->
<!--          rounded-md-->
<!--          h-[80px]-->
<!--          flex-->
<!--          justify-between-->
<!--          items-center-->
<!--          relative-->
<!--          shadow-md-->
<!--          max-w-[340px]-->
<!--          px-4-->
<!--          mb-2-->
<!--        "-->
<!--      >-->

<!--      <div class="flex items-center">-->
<!--        <a href="https://www.retino.com/" target="_blank">-->
<!--          <img src="/assets/partners/retino.png" class="w-auto -mt-1 h-8" alt="Retino logo">-->
<!--        </a>-->
<!--        <p class="text-big-body text-brand-gray-900 font-semibold">-->
<!--          Retino Afterparty-->
<!--        </p>-->
<!--      </div>-->

<!--        <svg-->
<!--          width="48"-->
<!--          height="48"-->
<!--          viewBox="0 0 48 48"-->
<!--          fill="none"-->
<!--          xmlns="http://www.w3.org/2000/svg"-->
<!--        >-->
<!--          <path-->
<!--            d="M23.5469 1.98048C23.2995 1.9715 23.0538 2.02385 22.8317 2.13286C22.6095 2.24188 22.4177 2.40416 22.2735 2.60526C22.1292 2.80636 22.037 3.04002 22.0049 3.28542C21.9729 3.53082 22.0021 3.78034 22.0898 4.01173C23.0275 6.59023 23.2056 8.47473 22.7383 10.2402C22.3426 11.735 21.3948 13.2555 19.8203 14.9883L18.8574 14.0254C17.9717 13.1397 16.741 12.8724 15.6269 13.1211C14.5129 13.3698 13.5153 14.1362 13.0898 15.3145L3.08983 42.9902C2.99329 43.2581 2.97498 43.548 3.03705 43.8259C3.09912 44.1038 3.23901 44.3583 3.44036 44.5596C3.64171 44.761 3.89622 44.9009 4.17412 44.963C4.45203 45.025 4.74187 45.0067 5.00976 44.9102L32.6875 34.9102V34.9121C35.0448 34.0625 35.7451 30.9167 33.9746 29.1445C33.9746 29.1439 33.9746 29.1432 33.9746 29.1426L33.0019 28.1699C34.7385 26.5903 36.2624 25.6405 37.7598 25.2442C39.5253 24.7768 41.4098 24.955 43.9883 25.8926C44.1737 25.9609 44.3708 25.9919 44.5683 25.9838C44.7657 25.9757 44.9596 25.9287 45.1389 25.8455C45.3181 25.7622 45.4791 25.6444 45.6126 25.4987C45.7462 25.353 45.8496 25.1824 45.9171 24.9967C45.9845 24.8109 46.0145 24.6136 46.0055 24.4162C45.9964 24.2188 45.9484 24.0251 45.8643 23.8463C45.7802 23.6675 45.6616 23.5071 45.5152 23.3742C45.3689 23.2414 45.1978 23.1388 45.0117 23.0723C43.551 22.5411 42.1675 22.1939 40.8379 22.0625C39.5083 21.9311 38.2325 22.0149 36.9902 22.3438C34.8345 22.9144 32.8789 24.176 30.8652 26.0332L26.582 21.75C27.0203 21.5797 27.4685 21.5494 28.1211 21.4961C29.276 21.4017 31.0694 21.1721 32.6191 19.6231C34.1695 18.0727 34.3974 16.2804 34.4922 15.125C34.5869 13.9696 34.5476 13.4521 35.498 12.502C36.4486 11.5518 36.9675 11.591 38.123 11.4961C39.2785 11.4012 41.0713 11.1716 42.6211 9.6211C42.8376 9.41024 42.9854 9.13888 43.0451 8.84258C43.1048 8.54628 43.0736 8.23886 42.9556 7.96061C42.8375 7.68235 42.6382 7.44623 42.3837 7.28319C42.1292 7.12014 41.8314 7.03778 41.5293 7.04689C41.1404 7.05874 40.7714 7.22121 40.5 7.50001C39.5498 8.45056 39.0322 8.41101 37.8769 8.50587C36.7217 8.60074 34.9274 8.83104 33.3769 10.3809C31.8264 11.9308 31.5986 13.7235 31.5039 14.8789C31.4091 16.0343 31.4486 16.5514 30.498 17.502C29.5487 18.4509 29.0321 18.4115 27.8769 18.5059C26.9687 18.5801 25.6652 18.7472 24.3965 19.5645L21.957 17.125C23.8091 15.1147 25.067 13.1622 25.6367 11.0098C26.2944 8.52529 25.9725 5.90979 24.9101 2.98829C24.811 2.70242 24.6278 2.4532 24.3845 2.27334C24.1412 2.09348 23.8492 1.99139 23.5469 1.98048ZM31 4.00001C30.6772 4.00001 30.3539 4.12265 30.1074 4.36915L29.3691 5.10743C28.8761 5.60043 28.8761 6.39959 29.3691 6.89259L30.1074 7.63087C30.6004 8.12287 31.3996 8.12287 31.8926 7.63087L32.6308 6.89259C33.1238 6.39959 33.1238 5.60043 32.6308 5.10743L31.8926 4.36915C31.6461 4.12265 31.3227 4.00001 31 4.00001ZM15 7.00001C14.6772 7.00001 14.3539 7.12265 14.1074 7.36915L13.3691 8.10743C12.8761 8.60043 12.8761 9.39959 13.3691 9.89259L14.1074 10.6309C14.6004 11.1229 15.3996 11.1229 15.8926 10.6309L16.6308 9.89259C17.1238 9.39959 17.1238 8.60043 16.6308 8.10743L15.8926 7.36915C15.6461 7.12265 15.3227 7.00001 15 7.00001ZM8.99999 11.5C8.67724 11.5 8.35391 11.6227 8.10741 11.8692L7.36913 12.6074C6.87613 13.1004 6.87613 13.8996 7.36913 14.3926L8.10741 15.1309C8.60041 15.6229 9.39957 15.6229 9.89257 15.1309L10.6309 14.3926C11.1238 13.8996 11.1238 13.1004 10.6309 12.6074L9.89257 11.8692C9.64607 11.6227 9.32274 11.5 8.99999 11.5ZM16.2656 15.9766C16.416 15.943 16.5841 15.9982 16.7344 16.1484C16.735 16.1484 16.7357 16.1484 16.7363 16.1484L31.8535 31.2656C32.1531 31.5672 32.0698 31.9438 31.6699 32.0879C31.6693 32.0886 31.6686 32.0892 31.668 32.0899L6.99608 41.0039L15.9101 16.332C15.9826 16.1313 16.1152 16.0102 16.2656 15.9766ZM40 16C39.6772 16 39.3539 16.1227 39.1074 16.3692L38.3691 17.1074C37.8761 17.6004 37.8761 18.3996 38.3691 18.8926L39.1074 19.6309C39.6004 20.1229 40.3996 20.1229 40.8926 19.6309L41.6309 18.8926C42.1239 18.3996 42.1239 17.6004 41.6309 17.1074L40.8926 16.3692C40.6461 16.1227 40.3227 16 40 16ZM40 29C39.6772 29 39.3539 29.1227 39.1074 29.3692L38.3691 30.1074C37.8761 30.6004 37.8761 31.3996 38.3691 31.8926L39.1074 32.6309C39.6004 33.1229 40.3996 33.1229 40.8926 32.6309L41.6309 31.8926C42.1239 31.3996 42.1239 30.6004 41.6309 30.1074L40.8926 29.3692C40.6461 29.1227 40.3227 29 40 29ZM37 36C36.6772 36 36.3539 36.1227 36.1074 36.3692L35.3691 37.1074C34.8761 37.6004 34.8761 38.3996 35.3691 38.8926L36.1074 39.6309C36.6004 40.1229 37.3996 40.1229 37.8926 39.6309L38.6309 38.8926C39.1239 38.3996 39.1239 37.6004 38.6309 37.1074L37.8926 36.3692C37.6461 36.1227 37.3227 36 37 36Z"-->
<!--            fill="#A6C71F"-->
<!--          />-->
<!--        </svg>-->
<!--      </div>-->
<!--    </article>-->
  </div>

  <div
    class="hidden md:block w-full grid-cols-2 mt-[72px]"
  >
<!--    <div class="mb-5">-->
<!--      <h2 class="text-center font-semibold text-[24px]">Leadhub sál</h2>-->
<!--    </div>-->

<!--    <div class="mb-5">-->
<!--      <h2 class="text-center font-semibold text-[24px]">-->
<!--         Smartsupp sál-->
<!--      </h2>-->
<!--    </div>-->
<!--    <div-->
<!--      class="-->
<!--        flex-->
<!--        items-center-->
<!--        justify-between-->
<!--        h-24-->
<!--        col-span-2-->
<!--        px-6-->
<!--        bg-white-->
<!--        rounded-md-->
<!--        shadow-md-->
<!--      "-->
<!--    >-->
<!--      <div>-->
<!--        <p class="font-semibold text-brand-green text-tiny">9:30—9:45</p>-->
<!--        <p class="font-semibold text-body">Zahájení konference</p>-->
<!--      </div>-->

<!--      <div>-->
<!--        <svg-->
<!--          width="48"-->
<!--          height="48"-->
<!--          viewBox="0 0 48 48"-->
<!--          fill="none"-->
<!--          xmlns="http://www.w3.org/2000/svg"-->
<!--        >-->
<!--          <path-->
<!--            d="M23.5469 1.98048C23.2995 1.9715 23.0538 2.02385 22.8317 2.13286C22.6095 2.24188 22.4177 2.40416 22.2735 2.60526C22.1292 2.80636 22.037 3.04002 22.0049 3.28542C21.9729 3.53082 22.0021 3.78034 22.0898 4.01173C23.0275 6.59023 23.2056 8.47473 22.7383 10.2402C22.3426 11.735 21.3948 13.2555 19.8203 14.9883L18.8574 14.0254C17.9717 13.1397 16.741 12.8724 15.6269 13.1211C14.5129 13.3698 13.5153 14.1362 13.0898 15.3145L3.08983 42.9902C2.99329 43.2581 2.97498 43.548 3.03705 43.8259C3.09912 44.1038 3.23901 44.3583 3.44036 44.5596C3.64171 44.761 3.89622 44.9009 4.17412 44.963C4.45203 45.025 4.74187 45.0067 5.00976 44.9102L32.6875 34.9102V34.9121C35.0448 34.0625 35.7451 30.9167 33.9746 29.1445C33.9746 29.1439 33.9746 29.1432 33.9746 29.1426L33.0019 28.1699C34.7385 26.5903 36.2624 25.6405 37.7598 25.2442C39.5253 24.7768 41.4098 24.955 43.9883 25.8926C44.1737 25.9609 44.3708 25.9919 44.5683 25.9838C44.7657 25.9757 44.9596 25.9287 45.1389 25.8455C45.3181 25.7622 45.4791 25.6444 45.6126 25.4987C45.7462 25.353 45.8496 25.1824 45.9171 24.9967C45.9845 24.8109 46.0145 24.6136 46.0055 24.4162C45.9964 24.2188 45.9484 24.0251 45.8643 23.8463C45.7802 23.6675 45.6616 23.5071 45.5152 23.3742C45.3689 23.2414 45.1978 23.1388 45.0117 23.0723C43.551 22.5411 42.1675 22.1939 40.8379 22.0625C39.5083 21.9311 38.2325 22.0149 36.9902 22.3438C34.8345 22.9144 32.8789 24.176 30.8652 26.0332L26.582 21.75C27.0203 21.5797 27.4685 21.5494 28.1211 21.4961C29.276 21.4017 31.0694 21.1721 32.6191 19.6231C34.1695 18.0727 34.3974 16.2804 34.4922 15.125C34.5869 13.9696 34.5476 13.4521 35.498 12.502C36.4486 11.5518 36.9675 11.591 38.123 11.4961C39.2785 11.4012 41.0713 11.1716 42.6211 9.6211C42.8376 9.41024 42.9854 9.13888 43.0451 8.84258C43.1048 8.54628 43.0736 8.23886 42.9556 7.96061C42.8375 7.68235 42.6382 7.44623 42.3837 7.28319C42.1292 7.12014 41.8314 7.03778 41.5293 7.04689C41.1404 7.05874 40.7714 7.22121 40.5 7.50001C39.5498 8.45056 39.0322 8.41101 37.8769 8.50587C36.7217 8.60074 34.9274 8.83104 33.3769 10.3809C31.8264 11.9308 31.5986 13.7235 31.5039 14.8789C31.4091 16.0343 31.4486 16.5514 30.498 17.502C29.5487 18.4509 29.0321 18.4115 27.8769 18.5059C26.9687 18.5801 25.6652 18.7472 24.3965 19.5645L21.957 17.125C23.8091 15.1147 25.067 13.1622 25.6367 11.0098C26.2944 8.52529 25.9725 5.90979 24.9101 2.98829C24.811 2.70242 24.6278 2.4532 24.3845 2.27334C24.1412 2.09348 23.8492 1.99139 23.5469 1.98048ZM31 4.00001C30.6772 4.00001 30.3539 4.12265 30.1074 4.36915L29.3691 5.10743C28.8761 5.60043 28.8761 6.39959 29.3691 6.89259L30.1074 7.63087C30.6004 8.12287 31.3996 8.12287 31.8926 7.63087L32.6308 6.89259C33.1238 6.39959 33.1238 5.60043 32.6308 5.10743L31.8926 4.36915C31.6461 4.12265 31.3227 4.00001 31 4.00001ZM15 7.00001C14.6772 7.00001 14.3539 7.12265 14.1074 7.36915L13.3691 8.10743C12.8761 8.60043 12.8761 9.39959 13.3691 9.89259L14.1074 10.6309C14.6004 11.1229 15.3996 11.1229 15.8926 10.6309L16.6308 9.89259C17.1238 9.39959 17.1238 8.60043 16.6308 8.10743L15.8926 7.36915C15.6461 7.12265 15.3227 7.00001 15 7.00001ZM8.99999 11.5C8.67724 11.5 8.35391 11.6227 8.10741 11.8692L7.36913 12.6074C6.87613 13.1004 6.87613 13.8996 7.36913 14.3926L8.10741 15.1309C8.60041 15.6229 9.39957 15.6229 9.89257 15.1309L10.6309 14.3926C11.1238 13.8996 11.1238 13.1004 10.6309 12.6074L9.89257 11.8692C9.64607 11.6227 9.32274 11.5 8.99999 11.5ZM16.2656 15.9766C16.416 15.943 16.5841 15.9982 16.7344 16.1484C16.735 16.1484 16.7357 16.1484 16.7363 16.1484L31.8535 31.2656C32.1531 31.5672 32.0698 31.9438 31.6699 32.0879C31.6693 32.0886 31.6686 32.0892 31.668 32.0899L6.99608 41.0039L15.9101 16.332C15.9826 16.1313 16.1152 16.0102 16.2656 15.9766ZM40 16C39.6772 16 39.3539 16.1227 39.1074 16.3692L38.3691 17.1074C37.8761 17.6004 37.8761 18.3996 38.3691 18.8926L39.1074 19.6309C39.6004 20.1229 40.3996 20.1229 40.8926 19.6309L41.6309 18.8926C42.1239 18.3996 42.1239 17.6004 41.6309 17.1074L40.8926 16.3692C40.6461 16.1227 40.3227 16 40 16ZM40 29C39.6772 29 39.3539 29.1227 39.1074 29.3692L38.3691 30.1074C37.8761 30.6004 37.8761 31.3996 38.3691 31.8926L39.1074 32.6309C39.6004 33.1229 40.3996 33.1229 40.8926 32.6309L41.6309 31.8926C42.1239 31.3996 42.1239 30.6004 41.6309 30.1074L40.8926 29.3692C40.6461 29.1227 40.3227 29 40 29ZM37 36C36.6772 36 36.3539 36.1227 36.1074 36.3692L35.3691 37.1074C34.8761 37.6004 34.8761 38.3996 35.3691 38.8926L36.1074 39.6309C36.6004 40.1229 37.3996 40.1229 37.8926 39.6309L38.6309 38.8926C39.1239 38.3996 39.1239 37.6004 38.6309 37.1074L37.8926 36.3692C37.6461 36.1227 37.3227 36 37 36Z"-->
<!--            fill="#A6C71F"-->
<!--          />-->
<!--        </svg>-->
<!--      </div>-->
<!--    </div>-->
    <div class="flex w-full">
      <div class="w-[50%]">
        <p class="lg:text-[64px] text-[32px] font-semibold">Program</p>
      </div>
      <div class="w-[50%]">
        <div  v-for="(happening, i) in programFiltered" :key="i">
          <div
            v-if="i === 0"
            class="
            max-w-[623px]
            md:max-w-none
            p-7
            bg-[#00120C]
            relative
            border
            border-[#19291E]
            "
          >
            <div class="flex items-center">
              <div class="mr-3 font-semibold text-brand-green text-[16px] font-mono">14:30</div>
              <div class="uppercase font-semibold text-brand-gray-500 text-[16px] font-mono">Notino pre-event</div>
            </div>
          </div>
          <ProgramCard
            :key="i"
            :programArticle="happening"
            @clicked="selectProgramArticle"
            :timeslotSelections="timeslotSelectionsMutable"
            :userLoggedIn="userLoggedIn"
            :program-voting-opened="votingOpened"
            @update:timeslotSelections="updateTimeSlot"
            :hasHappeningSiblingDown="hasHappeningSiblingDown(happening)"
            :hasHappeningSiblingUp="hasHappeningSiblingUp(happening)"
          />
          <div
            v-if="i === 0"
            class="
            max-w-[623px]
            md:max-w-none
            p-7
            bg-[#00120C]
            relative
            border
            border-[#19291E]
            "
          >
            <div class="flex items-center">
              <div class="mr-3 font-semibold text-brand-green text-[16px] font-mono">16:00</div>
              <div class="uppercase font-semibold text-brand-gray-500 text-[16px] font-mono">Slavnostní zahájení</div>
            </div>
          </div>
          <div
            v-if="i < programFiltered.length-1 && programFiltered[i+1].start !== happening.end && i !== 6 && i !== 0"
            class="
            max-w-[623px]
            md:max-w-none
            p-7
            bg-[#00120C]
            relative
            border
            border-[#19291E]
            "
          >
            <div class="flex items-center">
              <div class="uppercase font-semibold text-brand-gray-500 text-[16px] font-mono">Pauza</div>
            </div>
          </div>
          <div
            v-if="i === 6"
            class="
            max-w-[623px]
            md:max-w-none
            p-7
            bg-[#00120C]
            relative
            border
            border-[#19291E]
            "
          >
            <div class="flex items-center">
              <div class="uppercase font-semibold text-brand-gray-500 text-[16px] font-mono">Večeře</div>
            </div>
          </div>
        </div>
        <div
          class="
            md:min-h-[250px]
            max-w-[623px]
            md:max-w-none
            p-6
            bg-brand-gray-900
            relative
            border
            border-brand-green
          "
        >
          <div class="flex justify-between">
            <div class="flex">
              <svg class="w-[85px] h-[85px] mr-4 object-cover rounded-md" xmlns="http://www.w3.org/2000/svg" width="85" height="85" viewBox="0 0 50 43" fill="none">
                <circle cx="24.7368" cy="13.2232" r="5.71924" stroke="white" stroke-width="2.34378"/>
                <circle cx="37.9024" cy="18.879" r="4.12898" stroke="white" stroke-width="2.34378"/>
                <circle cx="11.5743" cy="18.879" r="4.12898" stroke="white" stroke-width="2.34378"/>
                <path d="M36.2235 35.3996C36.2235 28.8125 31.2792 23.4727 25.18 23.4727C19.0809 23.4727 14.1366 28.8125 14.1366 35.3996M19.6141 36.1947C19.6141 31.413 16.1135 27.5367 11.7953 27.5367C7.47715 27.5367 3.97656 31.413 3.97656 36.1947M45.7651 36.1947C45.7651 31.413 42.2645 27.5367 37.9463 27.5367C33.6281 27.5367 30.1275 31.413 30.1275 36.1947" stroke="white" stroke-width="2.34378" stroke-linecap="round"/>
              </svg>

              <div>
                <p class="font-semibold text-brand-green text-[14px] font-mono mb-3">
                  21:00-22:00
                </p>
                <p
                  class="
                    font-semibold
                    text-[24px]
                  "
                >
                  Mastermind skupiny a řízený networking
                </p>
              </div>
            </div>
          </div>
          <div class="mt-4 font-medium text-body  text-brand-gray-500">
            Zúčastněte se malých uzavřených skupin vedených zkušenými mentory a diskutujte s ostatními na konkrétní téma.
          </div>
          <div
            class="mt-6 mb-5"
          >
            <a
              :href="userLoggedIn ? '/#workshopy' : '/prihlaseni'"
              class="uppercase px-8 py-4 text-[16px] hover:opacity-80 text-black bg-brand-green border border-brand-green hover:border-brand-green hover:text-brand-green hover:bg-brand-gray-700 hover:cursor-pointer font-mono"
            >
              Přihlásit se
            </a>
          </div>
        </div>
        <div
          class="
            max-w-[623px]
            md:max-w-none
            p-2
            pl-2
            bg-[#00120C]
            relative
            border
            border-[#19291E]
            "
        >
          <div class="flex items-center">
            <div class="mr-4">
              <svg xmlns="http://www.w3.org/2000/svg" width="113" height="113" viewBox="0 0 113 113" fill="none">
                <path d="M55.5459 35.001C55.2986 34.992 55.0529 35.0444 54.8307 35.1534C54.6085 35.2624 54.4167 35.4247 54.2725 35.6258C54.1282 35.8269 54.036 36.0605 54.004 36.3059C53.9719 36.5513 54.0011 36.8008 54.0889 37.0322C55.0265 39.6107 55.2046 41.4952 54.7373 43.2608C54.3416 44.7555 53.3938 46.276 51.8193 48.0088L50.8564 47.0459C49.9707 46.1602 48.74 45.893 47.626 46.1416C46.5119 46.3903 45.5144 47.1567 45.0889 48.335L35.0889 76.0108C34.9923 76.2786 34.974 76.5685 35.0361 76.8464C35.0981 77.1243 35.238 77.3788 35.4394 77.5802C35.6407 77.7815 35.8952 77.9214 36.1731 77.9835C36.4511 78.0455 36.7409 78.0272 37.0088 77.9307L64.6865 67.9307V67.9326C67.0439 67.083 67.7441 63.9373 65.9736 62.1651C65.9736 62.1644 65.9736 62.1637 65.9736 62.1631L65.001 61.1904C66.7375 59.6109 68.2614 58.661 69.7588 58.2647C71.5243 57.7973 73.4088 57.9755 75.9873 58.9131C76.1727 58.9814 76.3698 59.0124 76.5673 59.0043C76.7647 58.9962 76.9587 58.9492 77.1379 58.866C77.3171 58.7827 77.4781 58.6649 77.6117 58.5192C77.7452 58.3736 77.8487 58.2029 77.9161 58.0172C77.9835 57.8314 78.0135 57.6341 78.0045 57.4367C77.9954 57.2393 77.9475 57.0456 77.8633 56.8668C77.7792 56.688 77.6606 56.5276 77.5143 56.3947C77.368 56.2619 77.1968 56.1593 77.0107 56.0928C75.55 55.5616 74.1665 55.2144 72.8369 55.083C71.5073 54.9516 70.2315 55.0354 68.9893 55.3643C66.8335 55.9349 64.8779 57.1965 62.8642 59.0537L58.581 54.7705C59.0193 54.6002 59.4676 54.5699 60.1201 54.5166C61.275 54.4222 63.0685 54.1926 64.6182 52.6436C66.1686 51.0932 66.3965 49.3009 66.4912 48.1455C66.586 46.9902 66.5466 46.4726 67.4971 45.5225C68.4476 44.5723 68.9666 44.6115 70.1221 44.5166C71.2776 44.4217 73.0703 44.1921 74.6201 42.6416C74.8367 42.4307 74.9844 42.1594 75.0441 41.8631C75.1038 41.5668 75.0726 41.2594 74.9546 40.9811C74.8366 40.7029 74.6372 40.4667 74.3827 40.3037C74.1282 40.1407 73.8304 40.0583 73.5283 40.0674C73.1394 40.0792 72.7704 40.2417 72.499 40.5205C71.5489 41.4711 71.0312 41.4315 69.876 41.5264C68.7207 41.6212 66.9264 41.8515 65.376 43.4014C63.8254 44.9513 63.5977 46.744 63.5029 47.8994C63.4082 49.0548 63.4476 49.5719 62.4971 50.5225C61.5478 51.4714 61.0311 51.432 59.876 51.5264C58.9677 51.6006 57.6642 51.7677 56.3955 52.585L53.956 50.1455C55.8082 48.1352 57.066 46.1827 57.6357 44.0303C58.2934 41.5458 57.9715 38.9303 56.9092 36.0088C56.8101 35.7229 56.6268 35.4737 56.3835 35.2938C56.1402 35.114 55.8483 35.0119 55.5459 35.001ZM62.999 37.0205C62.6763 37.0205 62.3529 37.1432 62.1064 37.3897L61.3682 38.1279C60.8752 38.6209 60.8752 39.4201 61.3682 39.9131L62.1064 40.6514C62.5994 41.1434 63.3986 41.1434 63.8916 40.6514L64.6299 39.9131C65.1229 39.4201 65.1229 38.6209 64.6299 38.1279L63.8916 37.3897C63.6451 37.1432 63.3218 37.0205 62.999 37.0205ZM46.999 40.0205C46.6763 40.0205 46.3529 40.1432 46.1064 40.3897L45.3682 41.1279C44.8752 41.6209 44.8752 42.4201 45.3682 42.9131L46.1064 43.6514C46.5994 44.1434 47.3986 44.1434 47.8916 43.6514L48.6299 42.9131C49.1229 42.4201 49.1229 41.6209 48.6299 41.1279L47.8916 40.3897C47.6451 40.1432 47.3218 40.0205 46.999 40.0205ZM40.999 44.5205C40.6763 44.5205 40.3529 44.6432 40.1064 44.8897L39.3682 45.6279C38.8752 46.1209 38.8752 46.9201 39.3682 47.4131L40.1064 48.1514C40.5994 48.6434 41.3986 48.6434 41.8916 48.1514L42.6299 47.4131C43.1229 46.9201 43.1229 46.1209 42.6299 45.6279L41.8916 44.8897C41.6451 44.6432 41.3218 44.5205 40.999 44.5205ZM48.2646 48.9971C48.4151 48.9635 48.5831 49.0187 48.7334 49.169C48.734 49.169 48.7347 49.169 48.7353 49.169L63.8525 64.2861C64.1521 64.5877 64.0689 64.9643 63.6689 65.1084C63.6683 65.1091 63.6676 65.1097 63.667 65.1104L38.9951 74.0244L47.9092 49.3525C47.9817 49.1518 48.1142 49.0307 48.2646 48.9971ZM71.999 49.0205C71.6763 49.0205 71.3529 49.1432 71.1064 49.3897L70.3682 50.1279C69.8752 50.6209 69.8752 51.4201 70.3682 51.9131L71.1064 52.6514C71.5994 53.1434 72.3986 53.1434 72.8916 52.6514L73.6299 51.9131C74.1229 51.4201 74.1229 50.6209 73.6299 50.1279L72.8916 49.3897C72.6451 49.1432 72.3218 49.0205 71.999 49.0205ZM71.999 62.0205C71.6763 62.0205 71.3529 62.1432 71.1064 62.3897L70.3682 63.1279C69.8752 63.6209 69.8752 64.4201 70.3682 64.9131L71.1064 65.6514C71.5994 66.1434 72.3986 66.1434 72.8916 65.6514L73.6299 64.9131C74.1229 64.4201 74.1229 63.6209 73.6299 63.1279L72.8916 62.3897C72.6451 62.1432 72.3218 62.0205 71.999 62.0205ZM68.999 69.0205C68.6763 69.0205 68.3529 69.1432 68.1064 69.3897L67.3682 70.1279C66.8752 70.6209 66.8752 71.4201 67.3682 71.9131L68.1064 72.6514C68.5994 73.1434 69.3986 73.1434 69.8916 72.6514L70.6299 71.9131C71.1229 71.4201 71.1229 70.6209 70.6299 70.1279L69.8916 69.3897C69.6451 69.1432 69.3218 69.0205 68.999 69.0205Z" fill="white"/>
                <g filter="url(#filter0_f_4256_4888)">
                  <path d="M55.5459 35.001C55.2986 34.992 55.0529 35.0444 54.8307 35.1534C54.6085 35.2624 54.4167 35.4247 54.2725 35.6258C54.1282 35.8269 54.036 36.0605 54.004 36.3059C53.9719 36.5513 54.0011 36.8008 54.0889 37.0322C55.0265 39.6107 55.2046 41.4952 54.7373 43.2608C54.3416 44.7555 53.3938 46.276 51.8193 48.0088L50.8564 47.0459C49.9707 46.1602 48.74 45.893 47.626 46.1416C46.5119 46.3903 45.5144 47.1567 45.0889 48.335L35.0889 76.0108C34.9923 76.2786 34.974 76.5685 35.0361 76.8464C35.0981 77.1243 35.238 77.3788 35.4394 77.5802C35.6407 77.7815 35.8952 77.9214 36.1731 77.9835C36.4511 78.0455 36.7409 78.0272 37.0088 77.9307L64.6865 67.9307V67.9326C67.0439 67.083 67.7441 63.9373 65.9736 62.1651C65.9736 62.1644 65.9736 62.1637 65.9736 62.1631L65.001 61.1904C66.7375 59.6109 68.2614 58.661 69.7588 58.2647C71.5243 57.7973 73.4088 57.9755 75.9873 58.9131C76.1727 58.9814 76.3698 59.0124 76.5673 59.0043C76.7647 58.9962 76.9587 58.9492 77.1379 58.866C77.3171 58.7827 77.4781 58.6649 77.6117 58.5192C77.7452 58.3736 77.8487 58.2029 77.9161 58.0172C77.9835 57.8314 78.0135 57.6341 78.0045 57.4367C77.9954 57.2393 77.9475 57.0456 77.8633 56.8668C77.7792 56.688 77.6606 56.5276 77.5143 56.3947C77.368 56.2619 77.1968 56.1593 77.0107 56.0928C75.55 55.5616 74.1665 55.2144 72.8369 55.083C71.5073 54.9516 70.2315 55.0354 68.9893 55.3643C66.8335 55.9349 64.8779 57.1965 62.8642 59.0537L58.581 54.7705C59.0193 54.6002 59.4676 54.5699 60.1201 54.5166C61.275 54.4222 63.0685 54.1926 64.6182 52.6436C66.1686 51.0932 66.3965 49.3009 66.4912 48.1455C66.586 46.9902 66.5466 46.4726 67.4971 45.5225C68.4476 44.5723 68.9666 44.6115 70.1221 44.5166C71.2776 44.4217 73.0703 44.1921 74.6201 42.6416C74.8367 42.4307 74.9844 42.1594 75.0441 41.8631C75.1038 41.5668 75.0726 41.2594 74.9546 40.9811C74.8366 40.7029 74.6372 40.4667 74.3827 40.3037C74.1282 40.1407 73.8304 40.0583 73.5283 40.0674C73.1394 40.0792 72.7704 40.2417 72.499 40.5205C71.5489 41.4711 71.0312 41.4315 69.876 41.5264C68.7207 41.6212 66.9264 41.8515 65.376 43.4014C63.8254 44.9513 63.5977 46.744 63.5029 47.8994C63.4082 49.0548 63.4476 49.5719 62.4971 50.5225C61.5478 51.4714 61.0311 51.432 59.876 51.5264C58.9677 51.6006 57.6642 51.7677 56.3955 52.585L53.956 50.1455C55.8082 48.1352 57.066 46.1827 57.6357 44.0303C58.2934 41.5458 57.9715 38.9303 56.9092 36.0088C56.8101 35.7229 56.6268 35.4737 56.3835 35.2938C56.1402 35.114 55.8483 35.0119 55.5459 35.001ZM62.999 37.0205C62.6763 37.0205 62.3529 37.1432 62.1064 37.3897L61.3682 38.1279C60.8752 38.6209 60.8752 39.4201 61.3682 39.9131L62.1064 40.6514C62.5994 41.1434 63.3986 41.1434 63.8916 40.6514L64.6299 39.9131C65.1229 39.4201 65.1229 38.6209 64.6299 38.1279L63.8916 37.3897C63.6451 37.1432 63.3218 37.0205 62.999 37.0205ZM46.999 40.0205C46.6763 40.0205 46.3529 40.1432 46.1064 40.3897L45.3682 41.1279C44.8752 41.6209 44.8752 42.4201 45.3682 42.9131L46.1064 43.6514C46.5994 44.1434 47.3986 44.1434 47.8916 43.6514L48.6299 42.9131C49.1229 42.4201 49.1229 41.6209 48.6299 41.1279L47.8916 40.3897C47.6451 40.1432 47.3218 40.0205 46.999 40.0205ZM40.999 44.5205C40.6763 44.5205 40.3529 44.6432 40.1064 44.8897L39.3682 45.6279C38.8752 46.1209 38.8752 46.9201 39.3682 47.4131L40.1064 48.1514C40.5994 48.6434 41.3986 48.6434 41.8916 48.1514L42.6299 47.4131C43.1229 46.9201 43.1229 46.1209 42.6299 45.6279L41.8916 44.8897C41.6451 44.6432 41.3218 44.5205 40.999 44.5205ZM48.2646 48.9971C48.4151 48.9635 48.5831 49.0187 48.7334 49.169C48.734 49.169 48.7347 49.169 48.7353 49.169L63.8525 64.2861C64.1521 64.5877 64.0689 64.9643 63.6689 65.1084C63.6683 65.1091 63.6676 65.1097 63.667 65.1104L38.9951 74.0244L47.9092 49.3525C47.9817 49.1518 48.1142 49.0307 48.2646 48.9971ZM71.999 49.0205C71.6763 49.0205 71.3529 49.1432 71.1064 49.3897L70.3682 50.1279C69.8752 50.6209 69.8752 51.4201 70.3682 51.9131L71.1064 52.6514C71.5994 53.1434 72.3986 53.1434 72.8916 52.6514L73.6299 51.9131C74.1229 51.4201 74.1229 50.6209 73.6299 50.1279L72.8916 49.3897C72.6451 49.1432 72.3218 49.0205 71.999 49.0205ZM71.999 62.0205C71.6763 62.0205 71.3529 62.1432 71.1064 62.3897L70.3682 63.1279C69.8752 63.6209 69.8752 64.4201 70.3682 64.9131L71.1064 65.6514C71.5994 66.1434 72.3986 66.1434 72.8916 65.6514L73.6299 64.9131C74.1229 64.4201 74.1229 63.6209 73.6299 63.1279L72.8916 62.3897C72.6451 62.1432 72.3218 62.0205 71.999 62.0205ZM68.999 69.0205C68.6763 69.0205 68.3529 69.1432 68.1064 69.3897L67.3682 70.1279C66.8752 70.6209 66.8752 71.4201 67.3682 71.9131L68.1064 72.6514C68.5994 73.1434 69.3986 73.1434 69.8916 72.6514L70.6299 71.9131C71.1229 71.4201 71.1229 70.6209 70.6299 70.1279L69.8916 69.3897C69.6451 69.1432 69.3218 69.0205 68.999 69.0205Z" fill="white"/>
                </g>
                <defs>
                  <filter id="filter0_f_4256_4888" x="0.624489" y="0.624489" width="111.757" height="111.771" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                    <feGaussianBlur stdDeviation="17.1878" result="effect1_foregroundBlur_4256_4888"/>
                  </filter>
                </defs>
              </svg>
            </div>
            <div>
              <div class="mr-3 font-semibold text-brand-green text-[16px] font-mono">21:00-24:00</div>
              <div class="font-semibold text-[20px]">Notino Afterparty</div>
            </div>
          </div>
        </div>


  <!--      <LunchCard :height="242" time="12:30—14:00"></LunchCard>-->

      </div>
    </div>

<!--    <div>-->
<!--      <ProgramCard-->
<!--        class="my-4"-->
<!--        :compact="i === 2"-->
<!--        :style="{ minHeight: i === 2 ? '200px' : '', maxHeight: i === 2 ? '200px' : ''}"-->
<!--        v-for="(happening, i) in secondHallMorning.slice(0, 3)"-->
<!--        :key="i"-->
<!--        :textTruncateChars="i === 2 ? 35 : 126"-->

<!--        :programArticle="happening"-->
<!--        @clicked="selectProgramArticle"-->
<!--        :timeslotSelections="timeslotSelectionsMutable"-->
<!--        :userLoggedIn="userLoggedIn"-->
<!--        :program-voting-opened="votingOpened"-->
<!--        @update:timeslotSelections="updateTimeSlot"-->
<!--        :hasHappeningSiblingDown="hasHappeningSiblingDown(happening)"-->
<!--        :hasHappeningSiblingUp="hasHappeningSiblingUp(happening)"-->
<!--      />-->
<!--      <LunchCard time="12:05—13:30"></LunchCard>-->

<!--      <ProgramCard-->
<!--        class="my-4"-->
<!--        :compact="true"-->
<!--        :style="{ minHeight: '200px', maxHeight:'200px'}"-->
<!--        :textTruncateChars="35"-->
<!--        :programArticle="secondHallMorning[3]"-->
<!--        @clicked="selectProgramArticle"-->
<!--        :timeslotSelections="timeslotSelectionsMutable"-->
<!--        :userLoggedIn="userLoggedIn"-->
<!--        :program-voting-opened="votingOpened"-->
<!--        @update:timeslotSelections="updateTimeSlot"-->
<!--        :hasHappeningSiblingDown="hasHappeningSiblingDown(secondHallMorning[3])"-->
<!--        :hasHappeningSiblingUp="hasHappeningSiblingUp(secondHallMorning[3])"-->
<!--      />-->

<!--    </div>-->



<!--    <div>-->
<!--      <template v-for="(happening, i) in firstHallAfterLunch"-->
<!--                :key="i">-->
<!--        <article class="md:min-h-[270px]" v-if="happening['placeholder']"></article>-->
<!--        <ProgramCard-->
<!--          v-else-->
<!--          :programArticle="happening['event']"-->
<!--          @clicked="selectProgramArticle"-->
<!--          :timeslotSelections="timeslotSelectionsMutable"-->
<!--          :userLoggedIn="userLoggedIn"-->
<!--          :program-voting-opened="votingOpened"-->
<!--          @update:timeslotSelections="updateTimeSlot"-->
<!--          :hasHappeningSiblingDown="hasHappeningSiblingDown(happening['event'])"-->
<!--          :hasHappeningSiblingUp="hasHappeningSiblingUp(happening['event'])"-->
<!--        />-->
<!--      </template>-->
<!--    </div>-->

<!--    <div>-->
<!--      <template v-for="(happening, i) in secondHallAfterLunch"-->
<!--                :key="i">-->
<!--        <article class="md:min-h-[270px]" v-if="happening['placeholder']"></article>-->
<!--        <ProgramCard-->
<!--          class="my-4"-->
<!--          :programArticle="happening['event']"-->
<!--          @clicked="selectProgramArticle"-->
<!--          :timeslotSelections="timeslotSelectionsMutable"-->
<!--          :userLoggedIn="userLoggedIn"-->
<!--          :program-voting-opened="votingOpened"-->
<!--          @update:timeslotSelections="updateTimeSlot"-->
<!--          :hasHappeningSiblingDown="hasHappeningSiblingDown(happening['event'])"-->
<!--          :hasHappeningSiblingUp="hasHappeningSiblingUp(happening['event'])"-->
<!--        />-->
<!--      </template>-->
<!--    </div>-->
<!--    <div-->
<!--      class="-->
<!--        flex-->
<!--        items-center-->
<!--        justify-between-->
<!--        h-24-->
<!--        col-span-2-->
<!--        px-6-->
<!--        bg-white-->
<!--        rounded-md-->
<!--        shadow-md-->
<!--      "-->
<!--    >-->
<!--      <div>-->
<!--        <p class="font-semibold text-brand-green text-tiny">18:00 - 22:00</p>-->
<!--        <p class="font-semibold text-body">Retino Afterparty</p>-->
<!--      </div>-->

<!--      <div class="flex items-center">-->
<!--        <a href="https://www.retino.com/" target="_blank">-->
<!--          <img  src="/assets/partners/retino.png" class="w-auto h-10" alt="Retino logo">-->
<!--        </a>-->
<!--        <svg-->
<!--          width="48"-->
<!--          height="48"-->
<!--          viewBox="0 0 48 48"-->
<!--          fill="none"-->
<!--          xmlns="http://www.w3.org/2000/svg"-->
<!--        >-->
<!--          <path-->
<!--            d="M23.5469 1.98048C23.2995 1.9715 23.0538 2.02385 22.8317 2.13286C22.6095 2.24188 22.4177 2.40416 22.2735 2.60526C22.1292 2.80636 22.037 3.04002 22.0049 3.28542C21.9729 3.53082 22.0021 3.78034 22.0898 4.01173C23.0275 6.59023 23.2056 8.47473 22.7383 10.2402C22.3426 11.735 21.3948 13.2555 19.8203 14.9883L18.8574 14.0254C17.9717 13.1397 16.741 12.8724 15.6269 13.1211C14.5129 13.3698 13.5153 14.1362 13.0898 15.3145L3.08983 42.9902C2.99329 43.2581 2.97498 43.548 3.03705 43.8259C3.09912 44.1038 3.23901 44.3583 3.44036 44.5596C3.64171 44.761 3.89622 44.9009 4.17412 44.963C4.45203 45.025 4.74187 45.0067 5.00976 44.9102L32.6875 34.9102V34.9121C35.0448 34.0625 35.7451 30.9167 33.9746 29.1445C33.9746 29.1439 33.9746 29.1432 33.9746 29.1426L33.0019 28.1699C34.7385 26.5903 36.2624 25.6405 37.7598 25.2442C39.5253 24.7768 41.4098 24.955 43.9883 25.8926C44.1737 25.9609 44.3708 25.9919 44.5683 25.9838C44.7657 25.9757 44.9596 25.9287 45.1389 25.8455C45.3181 25.7622 45.4791 25.6444 45.6126 25.4987C45.7462 25.353 45.8496 25.1824 45.9171 24.9967C45.9845 24.8109 46.0145 24.6136 46.0055 24.4162C45.9964 24.2188 45.9484 24.0251 45.8643 23.8463C45.7802 23.6675 45.6616 23.5071 45.5152 23.3742C45.3689 23.2414 45.1978 23.1388 45.0117 23.0723C43.551 22.5411 42.1675 22.1939 40.8379 22.0625C39.5083 21.9311 38.2325 22.0149 36.9902 22.3438C34.8345 22.9144 32.8789 24.176 30.8652 26.0332L26.582 21.75C27.0203 21.5797 27.4685 21.5494 28.1211 21.4961C29.276 21.4017 31.0694 21.1721 32.6191 19.6231C34.1695 18.0727 34.3974 16.2804 34.4922 15.125C34.5869 13.9696 34.5476 13.4521 35.498 12.502C36.4486 11.5518 36.9675 11.591 38.123 11.4961C39.2785 11.4012 41.0713 11.1716 42.6211 9.6211C42.8376 9.41024 42.9854 9.13888 43.0451 8.84258C43.1048 8.54628 43.0736 8.23886 42.9556 7.96061C42.8375 7.68235 42.6382 7.44623 42.3837 7.28319C42.1292 7.12014 41.8314 7.03778 41.5293 7.04689C41.1404 7.05874 40.7714 7.22121 40.5 7.50001C39.5498 8.45056 39.0322 8.41101 37.8769 8.50587C36.7217 8.60074 34.9274 8.83104 33.3769 10.3809C31.8264 11.9308 31.5986 13.7235 31.5039 14.8789C31.4091 16.0343 31.4486 16.5514 30.498 17.502C29.5487 18.4509 29.0321 18.4115 27.8769 18.5059C26.9687 18.5801 25.6652 18.7472 24.3965 19.5645L21.957 17.125C23.8091 15.1147 25.067 13.1622 25.6367 11.0098C26.2944 8.52529 25.9725 5.90979 24.9101 2.98829C24.811 2.70242 24.6278 2.4532 24.3845 2.27334C24.1412 2.09348 23.8492 1.99139 23.5469 1.98048ZM31 4.00001C30.6772 4.00001 30.3539 4.12265 30.1074 4.36915L29.3691 5.10743C28.8761 5.60043 28.8761 6.39959 29.3691 6.89259L30.1074 7.63087C30.6004 8.12287 31.3996 8.12287 31.8926 7.63087L32.6308 6.89259C33.1238 6.39959 33.1238 5.60043 32.6308 5.10743L31.8926 4.36915C31.6461 4.12265 31.3227 4.00001 31 4.00001ZM15 7.00001C14.6772 7.00001 14.3539 7.12265 14.1074 7.36915L13.3691 8.10743C12.8761 8.60043 12.8761 9.39959 13.3691 9.89259L14.1074 10.6309C14.6004 11.1229 15.3996 11.1229 15.8926 10.6309L16.6308 9.89259C17.1238 9.39959 17.1238 8.60043 16.6308 8.10743L15.8926 7.36915C15.6461 7.12265 15.3227 7.00001 15 7.00001ZM8.99999 11.5C8.67724 11.5 8.35391 11.6227 8.10741 11.8692L7.36913 12.6074C6.87613 13.1004 6.87613 13.8996 7.36913 14.3926L8.10741 15.1309C8.60041 15.6229 9.39957 15.6229 9.89257 15.1309L10.6309 14.3926C11.1238 13.8996 11.1238 13.1004 10.6309 12.6074L9.89257 11.8692C9.64607 11.6227 9.32274 11.5 8.99999 11.5ZM16.2656 15.9766C16.416 15.943 16.5841 15.9982 16.7344 16.1484C16.735 16.1484 16.7357 16.1484 16.7363 16.1484L31.8535 31.2656C32.1531 31.5672 32.0698 31.9438 31.6699 32.0879C31.6693 32.0886 31.6686 32.0892 31.668 32.0899L6.99608 41.0039L15.9101 16.332C15.9826 16.1313 16.1152 16.0102 16.2656 15.9766ZM40 16C39.6772 16 39.3539 16.1227 39.1074 16.3692L38.3691 17.1074C37.8761 17.6004 37.8761 18.3996 38.3691 18.8926L39.1074 19.6309C39.6004 20.1229 40.3996 20.1229 40.8926 19.6309L41.6309 18.8926C42.1239 18.3996 42.1239 17.6004 41.6309 17.1074L40.8926 16.3692C40.6461 16.1227 40.3227 16 40 16ZM40 29C39.6772 29 39.3539 29.1227 39.1074 29.3692L38.3691 30.1074C37.8761 30.6004 37.8761 31.3996 38.3691 31.8926L39.1074 32.6309C39.6004 33.1229 40.3996 33.1229 40.8926 32.6309L41.6309 31.8926C42.1239 31.3996 42.1239 30.6004 41.6309 30.1074L40.8926 29.3692C40.6461 29.1227 40.3227 29 40 29ZM37 36C36.6772 36 36.3539 36.1227 36.1074 36.3692L35.3691 37.1074C34.8761 37.6004 34.8761 38.3996 35.3691 38.8926L36.1074 39.6309C36.6004 40.1229 37.3996 40.1229 37.8926 39.6309L38.6309 38.8926C39.1239 38.3996 39.1239 37.6004 38.6309 37.1074L37.8926 36.3692C37.6461 36.1227 37.3227 36 37 36Z"-->
<!--            fill="#A6C71F"-->
<!--          />-->
<!--        </svg>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import ProgramCardModal from "./ProgramCardModal.vue";
import ProgramCard from "./ProgramCard.vue";
import ProgramCardMobile from "./ProgramCardMobile.vue";
import {isAfter, isBefore, parse} from "date-fns";
import LunchCard from "./LunchCard.vue";

export default {
  components: {
    ProgramCardModal,
    ProgramCard,
    ProgramCardMobile,
    LunchCard
},

  props: {
    programEvents: {
      type: Array,
      default: () => [],
    },

    timeslotSelections: {
      type: Object,
      default: undefined,
    },

    userLoggedIn: {
      type: Boolean,
      default: true,
    },

    votingOpened: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      selectedProgramArticle: null,
      hall1: "heureka",
      hall2: "purple",
      timeslotSelectionsMutable: this.timeslotSelections,
    };
  },

  computed: {
    canVote() {
      return this.userLoggedIn && this.votingOpened;
    },
    groupedByTimeSlots() {
      console.log(this.programEvents);
      const happenings = this.programEvents.filter(
        (event) => event.type !== "workshop" && event.timeslot !== null
      );

      const grouped = happenings.reduce((groupedHappenings, happening) => {
        if (groupedHappenings[happening.timeslot.index] == null) {
          groupedHappenings[happening.timeslot.index] = [];
        }

        if (
          groupedHappenings[happening.timeslot.index][happening.hall] == null
        ) {
          groupedHappenings[happening.timeslot.index][happening.hall] = [];
        }

        groupedHappenings[happening.timeslot.index][happening.hall].push(
          happening
        );

        return groupedHappenings;
      }, {});

      return grouped;
    },

    firstHall() {
      return this.programEvents
        .filter((e) => e.hall === this.hall1)
        .sort((firstEvent, secondEvent) => {
          const isBef = isBefore(
            parse(firstEvent.start, "HH:mm", new Date()),
            parse(secondEvent.start, "HH:mm", new Date())
          );

          //Safari coertion fix
          return isBef ? -1 : 1;
        });
    },

    secondHall() {
      return this.programEvents
        .filter((e) => e.hall === this.hall2)
        .sort((firstEvent, secondEvent) => {
          const isBef = isBefore(
            parse(firstEvent.start, "HH:mm", new Date()),
            parse(secondEvent.start, "HH:mm", new Date())
          );

          //Safari coertion fix
          return isBef ? -1 : 1;
        });
    },

    programFiltered(){
      console.log('events: ', this.programEvents);
      const program = this.programEvents.filter(
        (event) => event.type !== "workshop"
      );
      console.log('program: ', program);

      return program;
    },

    firstHallMorning() {
      return this.firstHall.filter(event => !this.isAfterLunch(event))
    },

    secondHallMorning() {
      return this.secondHall.filter(event => !this.isAfterLunch(event))
    },

    firstHallAfterLunch() {
      return this.getEventsWithPlaceholders()[0];
    },

    secondHallAfterLunch() {
      return this.getEventsWithPlaceholders()[1];
    },
  },

  methods: {
    getEventsWithPlaceholders() {
        const byTimeslotAfternoon = this.groupedByTimeSlots;

        const halls = [[], []];

        for (const timeslot in Object.keys(byTimeslotAfternoon)) {
          if (Number(timeslot) < 3) continue; // only consider afternoon events
          const group = byTimeslotAfternoon[timeslot];
          const firstHall = group.heureka || [];
          const secondHall = group.purple || [];

          const maxSize = Math.max(firstHall.length, secondHall.length);
          for (const event of firstHall) {
            halls[0].push({ "event": event, "placeholder": false });
          }
          for (const event of secondHall) {
            halls[1].push({ "event": event, "placeholder": false });
          }
          for (let i = firstHall.length; i < maxSize; i++) {
            halls[0].push({ "placeholder": true });
          }
          for (let i = secondHall.length; i < maxSize; i++) {
            halls[1].push({ "placeholder": true });
          }
        }

        return halls;
    },
    parseDate(time) {
      return parse(time, "HH:mm", new Date());
    },
    isAfterLunch(event) {
      const date = this.parseDate(event.start);
      const lunch = this.parseDate("13:30");
      return isAfter(date, lunch);
    },
    selectProgramArticle(article) {
      this.selectedProgramArticle = article;

      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('programId', article.id)

      const newRelativePathQuery = window.location.pathname + '?' + urlParams.toString();
      history.pushState(null, '', newRelativePathQuery);

    },
    clearSelectedArticle() {
      this.selectedProgramArticle = undefined;
      history.pushState(null, '',  window.location.pathname);
    },
    updateTimeSlot(newTimeSlots) {
      this.timeslotSelectionsMutable = { ...newTimeSlots };
    },

    hasHappeningSiblingUp(happening) {
      if (happening === undefined) return false;
      if (!happening.timeslot) return false;

      if (
        this.groupedByTimeSlots[happening.timeslot.index][happening.hall]
          .length === 1
      ) {
        return false;
      }

      const indexInArray = this.groupedByTimeSlots[happening.timeslot.index][
        happening.hall
      ].findIndex((h) => h.id === happening.id);

      if (indexInArray === 0) {
        return false;
      }

      return true;
    },

    hasHappeningSiblingDown(happening) {
      if (happening === undefined) return false;
      if (!happening.timeslot) return false;

      if (
        this.groupedByTimeSlots[happening.timeslot.index][happening.hall]
          .length === 1
      ) {
        return false;
      }

      const indexInArray = this.groupedByTimeSlots[happening.timeslot.index][
        happening.hall
      ].findIndex((h) => h.id === happening.id);

      if (
        indexInArray <
        this.groupedByTimeSlots[happening.timeslot.index][happening.hall]
          .length -
          1
      ) {
        return true;
      }

      return false;
    },

    selectArticleIfPresentInSearchParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const programId = urlParams.get('programId');

      if(programId !== undefined) {
        this.programEvents.forEach((event) => {
          if (event.id === Number(programId)) {
            this.selectProgramArticle(event);
          }
        });
      }
    }
  },

  mounted() {
    this.selectArticleIfPresentInSearchParams();
  }
};
</script>

<style>
</style>
